import { render, staticRenderFns } from "./CreateTaskModal.vue?vue&type=template&id=6799023c&scoped=true&"
import script from "./CreateTaskModal.vue?vue&type=script&lang=js&"
export * from "./CreateTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6799023c",
  null
  
)

export default component.exports